import { HashRouter, Routes, Route } from "react-router-dom";
import { Navbar, Footer } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import Knowledge from "@/pages/Knowledge";

export default function App() {
  return (
    <HashRouter>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/knowledge" element={<Knowledge />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HashRouter>
  );
}
